import miniToastr from "mini-toastr";
import moment from "moment";
moment.locale("es");

import { fechaBagno } from "@/assets/js/bagno_utils.js";

var selected_device;
var devices = [];

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

export function setup() {
  BrowserPrint.getDefaultDevice(
    "printer",
    function (device) {
      selected_device = device;
      console.log(selected_device);
      devices.push(device);

      var option = document.createElement("option");
      option.text = device.name;

      BrowserPrint.getLocalDevices(
        function (device_list) {
          for (var i = 0; i < device_list.length; i++) {
            var device = device_list[i];
            if (!selected_device || device.uid != selected_device.uid) {
              devices.push(device);
              var option = document.createElement("option");
              option.text = device.name;
              option.value = device.uid;
              html_select.add(option);
            }
          }
        },
        function () {
          miniToastr.info("Error al obtener los dispositivos locales.", "");
        },
        "printer"
      );
    },
    function (error) {
      miniToastr.info("Error al detectar la impresora.", "");
    }
  );
}

export function BagnoLabels(dataToWrite, typeLabel, numbrePrint) {
  console.log("Bagno Labels");
  //Etiqueta  pulgadas - 10 x 7 cm

  // RECEPCIONES 203DPI
  if (typeLabel == "recepcion-203dpi") {
    //console.log("%o",dataToWrite);

    selected_device.send(
      "^XA\
    ^FO40,50^GFA,2904,2904,33,hR01FF,7OF8gY01LF,7OF8gY05LF,7PFgY0MFE4,7PFCgW07FFE03IFC,78M07FF8gV0FFCJ0IFC,78N07F8gU07FCL0FF8,78N01FEgT02FFM03FE,78O07FgT05FCN07F8,78O03FgS01FFO03FD,78P0FCgS0FEP0FE8,78P0FCgR01F8P03FC,78P07CgR03FQ01FE,78P03EgR07ER0FF,78P03EgR0F8R07F8,78P01FgQ01FS03F,78P01F8P01CIF78S03ES01F8,78Q0FQ08KF8S07CT0FC,78Q0F8KFEJ0RFCI01JF8T07E,78Q0F9KFEI07RFCI01JF8T03F,78Q0F9LF8007FEI0NFI01JFU01F,78Q0NF001FFK0MFI01IFEV0F8,78J03CK07FCI01F007F8K03EI01F8001EY0F8,78J07FK07FCJ0F00FEM06J0FD001EY07C,78J07F8J07F8J0FC1F8R07E001EY07C,78J07F8J07F8J0783FS03F001EY03F,78J07F8J07F8J07C7CS01F001EO07FFM03E,78J07F8J0FFK07CF8S01FC01EN01IFEL01E,78J07F8J0FFK03FFU0FC01EN07JFL01F8,78J07F8J0FEK03FEU07E01EN0KFCK01F8,78J07FK0FEK03FCU03E01EM01KFEL0F8,78J03EK0FEK01F8U01F01EM03LFL0F8,78P01FCK01F8V0F81EM07LF8K0F8,78P01FCK01FW0FE1EM07LF8K078,78P03FCL0EW07F1EM0MFCK078,78P07F8L0EL0EP03F1EM0MFCK07C,78P07F8L04K0FFEO01F3EL01MFEK07C,78P0FFR01IFO01FFEL01MFEK07C,78P0FFR07IF8O0FFEL03MFEK07C,78P03FR0JFCO07FEL03NFK07C,78Q0ER0JFEO03FEL03NFK07C,78Q06Q01JFEO01FEL03NFK07C,78gI01KF0EN0FEL03NFK07C,78gI03KFBEN0FEL03NFK07C,78gI03LFEN07EL03NFK07C,784K018004K01K083FF8N010083EK043NF040087C,784O0104002L087FFS01EK043NFJ087C,784008M084002L087FFM01L0EK043NFJ087C,784008M084003L087FFM01002I0E1J043MFEJ087C,7840083F004008410704I0187FFM0100303061J041MFE180187C,787FF87FF07KF0707JF87FF0MF0C1FF801JFE1MFE1IF87C,787FF87FF83KF0F87JF87FF07LF0C1FF801JFE1MFC1IF078,787FF87FF83KF0F83JF87FF07LF0E0FFC01JFE0MFC3IF0F8,787FF87FFC3JFE0F83JF87FF0MF0F07FE01JFE07LF83IF0F8,787FF87FFC3JFE0F83JF87FF0MF0F83FF01KF87LF83IF0F8,787FF87FFC3JFEI03JF83FFI03JF0F83FF81KF83LF07IF0F,787FF87FFC3JFEI01JF83FFJ0JF0FC1FFC1KFC1KFE0IFE1F8,787FF87FF83JFCI01JFC3FFJ0JF0FE0FFC1KFC0KFC1IFE1F8,787FF87FF83JFEI01JFC1FFJ0JF0FF07FE1KFE07JF83IFC1E,787FF87FF07SFE1JFC0JF0FF87FF1LF01IFE03IFC3E,787FF83FC0TFE0JFE1JF0FF83OFC07FF80JF83E,787FF8I01UF07IFC1JF0FFC1OFE007801JF87C,787FF8I03UF03IFC3JF0FFE0PFK03JF07C,787FFCI07UF81IF83JF0FBF07OFCJ0KF0FC,787FFC007VFC07FC07JF0F9F87JF1KF8007JFE0F8,787RFK07JFEK0KF0F8F83JF1LFCLFC1F,787RFK03KFJ01KF0F87C1JF0SFC3F8,787QFEK03KFCI07KF0F87E0JF07RF83E,787QFEK03LF803LF0F87F07IF03RF07E,787QFC1IFE1RF3FF0F81F07IF01QFE0FC,787QFC3IFE1FFDNFE1FF0F82F83IF00QFC1FC,787QF87IFE1FF87MF83FF0F817C1IF007PF83F,787QF87JF0FFC1MF03FF0F807E0IF001OFE07F,78NFE3FF87JF0FFC0LFC03FF0F807F0IF0C0OFC0FE,787KFE001FF0FE01F87FC01KF001FF0F805F07FF0E03NF81FC,78S0F80078K01IFM0F800F8J0F80MFC03F8,78R01FI078Q0EJ0F8007CJ0FC03LF00FF,78R01F8007CP03EJ0F8007EJ0FE007JFC01FE,7TFEI0MFJ01MF8003MF8003FFI07FF,7TFE8007MF001NF8001NFM01FF8,7TFEI03XF8001NFCL0FFE,7TFCI01XF8I07NF8J07FF8,7TFEI01XFJ03KF6JF01IFE8,gL0KF8W07NFC,gM01FCg0MFE4,hP04KFE4,hQ0KFE,,^FS\
    ^FX Top section with logo, name and address.\
    ^CF0,40\
    ^FO350,60^FDRECEPCION DE FRUTA^FS\
    ^CF0,30\
    ^FO400,120^FDFECHA: " +
        dataToWrite.fecha_formato_bagno +
        "^FS\
    ^CF0,40\
    ^FO40,160^FD" +
        eliminarDiacriticos(dataToWrite.code) +
        "^FS\
    ^CF0,35\
    ^FO40,205^FD" +
        eliminarDiacriticos(dataToWrite.description) +
        "^FS\
    ^FO170,250^A0N,32,32^FB500,1,0,C^FDGUIA:" +
        eliminarDiacriticos(dataToWrite.document_number) +
        "^FS\
    ^FX Second section with recipient address and permit information.\
    ^CFA,25\
    ^FO50,300^FD" +
        eliminarDiacriticos(dataToWrite.quantity) +
        " " +
        eliminarDiacriticos(dataToWrite.container.text) +
        "^FS\
    ^FO50,340^FDLOTE " +
        eliminarDiacriticos(dataToWrite.lot) +
        "^FS\
    ^FO50,380^FD" +
        eliminarDiacriticos(dataToWrite.pallet_type) +
        "^FS\
    ^FO50,420^FDPESO BRUTO " +
        eliminarDiacriticos(dataToWrite.gross_weight) +
        " KG^FS\
    ^FO50,460^FDPESO NETO " +
        eliminarDiacriticos(dataToWrite.net_weight) +
        " KG^FS\
    ^FO540,220^BY4,2.0,65^BQ,2,8^FDQA," +
        eliminarDiacriticos(dataToWrite.number) +
        "^FS\
    ^FO50,500^GB700,1,3^FS\
    ^PQ" +
        numbrePrint +
        "\
        ^CN\
    ^XZ",
      successCallback,
      errorCallback
    );
  }

  // RECEPCIONES 300DPI
  if (typeLabel == "recepcion-300dpi") {
    //console.log("%o",dataToWrite);

    selected_device.send(
      `^XA
    ^MMT
    ^PW1181
    ^LL827
    ^LS0
    ^FO40,50^GFA,2904,2904,33,hR01FF,7OF8gY01LF,7OF8gY05LF,7PFgY0MFE4,7PFCgW07FFE03IFC,78M07FF8gV0FFCJ0IFC,78N07F8gU07FCL0FF8,78N01FEgT02FFM03FE,78O07FgT05FCN07F8,78O03FgS01FFO03FD,78P0FCgS0FEP0FE8,78P0FCgR01F8P03FC,78P07CgR03FQ01FE,78P03EgR07ER0FF,78P03EgR0F8R07F8,78P01FgQ01FS03F,78P01F8P01CIF78S03ES01F8,78Q0FQ08KF8S07CT0FC,78Q0F8KFEJ0RFCI01JF8T07E,78Q0F9KFEI07RFCI01JF8T03F,78Q0F9LF8007FEI0NFI01JFU01F,78Q0NF001FFK0MFI01IFEV0F8,78J03CK07FCI01F007F8K03EI01F8001EY0F8,78J07FK07FCJ0F00FEM06J0FD001EY07C,78J07F8J07F8J0FC1F8R07E001EY07C,78J07F8J07F8J0783FS03F001EY03F,78J07F8J07F8J07C7CS01F001EO07FFM03E,78J07F8J0FFK07CF8S01FC01EN01IFEL01E,78J07F8J0FFK03FFU0FC01EN07JFL01F8,78J07F8J0FEK03FEU07E01EN0KFCK01F8,78J07FK0FEK03FCU03E01EM01KFEL0F8,78J03EK0FEK01F8U01F01EM03LFL0F8,78P01FCK01F8V0F81EM07LF8K0F8,78P01FCK01FW0FE1EM07LF8K078,78P03FCL0EW07F1EM0MFCK078,78P07F8L0EL0EP03F1EM0MFCK07C,78P07F8L04K0FFEO01F3EL01MFEK07C,78P0FFR01IFO01FFEL01MFEK07C,78P0FFR07IF8O0FFEL03MFEK07C,78P03FR0JFCO07FEL03NFK07C,78Q0ER0JFEO03FEL03NFK07C,78Q06Q01JFEO01FEL03NFK07C,78gI01KF0EN0FEL03NFK07C,78gI03KFBEN0FEL03NFK07C,78gI03LFEN07EL03NFK07C,784K018004K01K083FF8N010083EK043NF040087C,784O0104002L087FFS01EK043NFJ087C,784008M084002L087FFM01L0EK043NFJ087C,784008M084003L087FFM01002I0E1J043MFEJ087C,7840083F004008410704I0187FFM0100303061J041MFE180187C,787FF87FF07KF0707JF87FF0MF0C1FF801JFE1MFE1IF87C,787FF87FF83KF0F87JF87FF07LF0C1FF801JFE1MFC1IF078,787FF87FF83KF0F83JF87FF07LF0E0FFC01JFE0MFC3IF0F8,787FF87FFC3JFE0F83JF87FF0MF0F07FE01JFE07LF83IF0F8,787FF87FFC3JFE0F83JF87FF0MF0F83FF01KF87LF83IF0F8,787FF87FFC3JFEI03JF83FFI03JF0F83FF81KF83LF07IF0F,787FF87FFC3JFEI01JF83FFJ0JF0FC1FFC1KFC1KFE0IFE1F8,787FF87FF83JFCI01JFC3FFJ0JF0FE0FFC1KFC0KFC1IFE1F8,787FF87FF83JFEI01JFC1FFJ0JF0FF07FE1KFE07JF83IFC1E,787FF87FF07SFE1JFC0JF0FF87FF1LF01IFE03IFC3E,787FF83FC0TFE0JFE1JF0FF83OFC07FF80JF83E,787FF8I01UF07IFC1JF0FFC1OFE007801JF87C,787FF8I03UF03IFC3JF0FFE0PFK03JF07C,787FFCI07UF81IF83JF0FBF07OFCJ0KF0FC,787FFC007VFC07FC07JF0F9F87JF1KF8007JFE0F8,787RFK07JFEK0KF0F8F83JF1LFCLFC1F,787RFK03KFJ01KF0F87C1JF0SFC3F8,787QFEK03KFCI07KF0F87E0JF07RF83E,787QFEK03LF803LF0F87F07IF03RF07E,787QFC1IFE1RF3FF0F81F07IF01QFE0FC,787QFC3IFE1FFDNFE1FF0F82F83IF00QFC1FC,787QF87IFE1FF87MF83FF0F817C1IF007PF83F,787QF87JF0FFC1MF03FF0F807E0IF001OFE07F,78NFE3FF87JF0FFC0LFC03FF0F807F0IF0C0OFC0FE,787KFE001FF0FE01F87FC01KF001FF0F805F07FF0E03NF81FC,78S0F80078K01IFM0F800F8J0F80MFC03F8,78R01FI078Q0EJ0F8007CJ0FC03LF00FF,78R01F8007CP03EJ0F8007EJ0FE007JFC01FE,7TFEI0MFJ01MF8003MF8003FFI07FF,7TFE8007MF001NF8001NFM01FF8,7TFEI03XF8001NFCL0FFE,7TFCI01XF8I07NF8J07FF8,7TFEI01XFJ03KF6JF01IFE8,gL0KF8W07NFC,gM01FCg0MFE4,hP04KFE4,hQ0KFE,,^FS\
    ^FT151,224^A0N,67,71^FH\^CI28^FD${eliminarDiacriticos(dataToWrite.code)} ${eliminarDiacriticos(
        dataToWrite.description
      )}^FS^CI27
    ^FT335,65^A0N,50,53^FH\^CI28^FDRECEPCION DE FRUTAS^FS^CI27
    ^FT416,124^A0N,33,38^FH\^CI28^FDFECHA^FS^CI27
    ^FT444,312^A0N,42,46^FH\^CI28^FDGUIA:^FS^CI27
    ^FT58,404^A0N,58,61^FH\^CI28^FDLOTE:^FS^CI27
    ^FT575,400^A0N,58,63^FH\^CI28^FD  ^FS^CI27
    ^FT209,400^A0N,58,66^FH\^CI28^FD${eliminarDiacriticos(dataToWrite.lot)} | N: ${dataToWrite.idx}^FS^CI27
    ^FT201,494^A0N,54,56^FH\^CI28^FD${eliminarDiacriticos(dataToWrite.container.text)}^FS^CI27
    ^FT62,575^A0N,50,53^FH\^CI28^FD${eliminarDiacriticos(dataToWrite.pallet_type)}^FS^CI27
    ^FT60,749^A0N,50,53^FH\^CI28^FDPESO NETO^FS^CI27
    ^FT359,749^A0N,50,53^FH\^CI28^FD${eliminarDiacriticos(dataToWrite.net_weight)}^FS^CI27
    ^FT62,652^A0N,50,53^FH\^CI28^FDPESO BRUTO^FS^CI27
    ^FT355,648^A0N,50,53^FH\^CI28^FD${eliminarDiacriticos(dataToWrite.gross_weight)}^FS^CI27
    ^FT528,751^A0N,50,53^FH\^CI28^FDKILOS^FS^CI27
    ^FT528,649^A0N,50,53^FH\^CI28^FDKILOS^FS^CI27
    ^FT92,496^A0N,50,53^FH\^CI28^FD${dataToWrite.quantity}^FS^CI27
    ^FT553,317^A0N,50,53^FH\^CI28^FD${eliminarDiacriticos(dataToWrite.document_number)}^FS^CI27
    ^FT526,123^A0N,33,38^FH\^CI28^FD${dataToWrite.fecha_formato_bagno}^FS^CI27
    ^FO700,400^BY4,2.0,65^BQ,2,10^FDQA,${eliminarDiacriticos(dataToWrite.number)}^FS\
    ^PQ${numbrePrint},0,1,Y
    ^CN
    ^XZ`,
      successCallback,
      errorCallback
    );
  }

  // DEVOLUCIONES 203DPI
  if (typeLabel == "devoluciones-203dpi") {
    // console.log("%o", dataToWrite);

    selected_device.send(
      `^XA\
      ~TA000\
      ~JSN\
      ^LT0\
      ^MNW\
      ^MTT\
      ^PON\
      ^PMN\
      ^LH0,0\
      ^JMA\
      ^PR6,6\
      ~SD28\
      ^JUS\
      ^LRN\
      ^CI27\
      ^PA0,1,1,0\
      ^XZ\
      ##                            ^XA\
      ^MMT\
      ^PW799\
      ^LL559\
      ^LS0\
      ^FO50,50^GFA,936,936,18,,::0F82gJ07E,0KFCg07FFE,0E001FFY03F81FC,0CJ078X0F8001F,0CJ01CW01EJ078,0CK0EW038J01E,0CK07W0FL0F,0CK03V01CL078,0CK038L07CM018L01C,0CK019FFE00LFC03FFM01C,0CK01BFFE03F07IFE03FFN0E,0CK01F0060FI0700E038O07,0C007001E0071CL0703P03,0C007801E00338L0383P038,0C007801E003FM01C3K0FFI018,0C007001C003EN0E3J03FF80018,0C006003C001CN0E3J07FFC001C,0CK0380018N073J0IFEI0C,0CK078I08N03BJ0JFI0C,0CK078K01FCJ01FI01JFI0C,0CK03L03FEK0FI01JFI0C,0C8J01L07FFK0FI01JFI0C,0C8I0182022027FF320427I09JF104C,0C801E042402447C00J231009JF104C,0C8201024492447C0022J1009JF104C,0C820082489184FC00221281009JF20CC,0CA27C41A99014FCFFC24841008JF208C,0CBA7E5E69CBF4FC803245217F4IFE2E9C,0CBA7E5FD00BF47CIFA62A17F47FFE5E9C,0CBE7E5FD00FFE7C02FE71517FA3FFCFF18,0CBE7C5FF007FA7C02FE79E9IF1FF0FD38,0CFE70MFE3FE3FE7CKF87C1FF38,0CFE01IF81IF1FE7FE7C7JFC007FE3,0CFE07NF8787FE6E3FE7FF01FFC7,0CLFC003FFC00FFE671FE3LFCE2,0CLFC001IF03FFE639FF1LF8E,0CLFCFF9F7JF3E61CFF0LF1C,0CLF8FF9F1IFC3E60C7F07JFE38,0CIFE0F9C18F87FF03E60E3F23JF87,0CL0181CI03010060700307FFE1E,0CJ080380C01800700603803C0FF03C,0NF80JF07IFE01JFJ0F8,0NF00OFE01JFE00FE,T01FFK08I01JF8,gH04J07FFC04,gG082N01,T02008N02J04,gM07002,,^FS\
      ^FO442,452^GB98,56,1^FS\
      ^FO116,328^GB73,50,1^FS\
      ^FO441,396^GB99,54,1^FS\
      ^FT88,259^A0N,51,53^FH^CI28^FD${eliminarDiacriticos(dataToWrite.code)} ${eliminarDiacriticos(
        dataToWrite.description
      )}^FS^CI27\
      ^FO45,205^GB702,78,1^FS\
      ^FT227,44^A0N,34,35^FH^CI28^FDDEVOLUCION DE FRUTAS^FS^CI27\
      ^FT278,132^A0N,23,25^FH^CI28^FDFECHA^FS^CI27\
      ^FT290,180^A0N,28,30^FH^CI28^FDGUIA:^FS^CI27\
      ^FT246,363^A0N,37,38^FH^CI28^FD${eliminarDiacriticos(dataToWrite.container.text)}^FS^CI27\
      ^FT86,435^A0N,34,35^FH^CI28^FD${dataToWrite.pallet_type}^FS^CI27\
      ^FT245,491^A0N,34,35^FH^CI28^FDPESO NETO^FS^CI27\
      ^FT454,493^A0N,34,35^FH^CI28^FD${dataToWrite.net_weight}^FS^CI27\
      ^FT243,436^A0N,34,35^FH^CI28^FDPESO BRUTO^FS^CI27\
      ^FT452,438^A0N,34,35^FH^CI28^FD${dataToWrite.gross_weight}^FS^CI27\
      ^FT551,495^A0N,34,35^FH^CI28^FDKILOS^FS^CI27\
      ^FT549,437^A0N,34,35^FH^CI28^FDKILOS^FS^CI27\
      ^FT128,369^A0N,34,35^FH^CI28^FD${dataToWrite.quantity}^FS^CI27\
      ^FT369,180^A0N,34,35^FH^CI28^FD${dataToWrite.company_waybill.number}^FS^CI27\
      ^FT336,90^A0N,31,33^FH^CI28^FDN ${pad(dataToWrite.product_return_id, 4)}^FS^CI27\
      ^FO560,0^BY4,2.0,65^BQ,2,6^FDQA,${eliminarDiacriticos(dataToWrite.number)}^FS\
      ^FT353,133^A0N,28,30^FH^CI28^FD${moment(dataToWrite.document_date).format("L")}^FS^CI27\
      ^PQ${numbrePrint},0,1,Y\
      ^CN
      ^XZ`,
      successCallback,
      errorCallback
    );
  }

  // DEVOLUCIONES 300DPI
  if (typeLabel == "devoluciones-300dpi") {
    //console.log("%o",dataToWrite);

    selected_device.send(
      `^XA\
      ~TA000\
      ~JSN\
      ^LT0\
      ^MNW\
      ^MTT\
      ^PON\
      ^PMN\
      ^LH0,0\
      ^JMA\
      ^PR6,6\
      ~SD28\
      ^JUS\
      ^LRN\
      ^CI27\
      ^PA0,1,1,0\
      ^XZ\
      ##                            ^XA\
      ^FO40,50^GFA,2904,2904,33,hR01FF,7OF8gY01LF,7OF8gY05LF,7PFgY0MFE4,7PFCgW07FFE03IFC,78M07FF8gV0FFCJ0IFC,78N07F8gU07FCL0FF8,78N01FEgT02FFM03FE,78O07FgT05FCN07F8,78O03FgS01FFO03FD,78P0FCgS0FEP0FE8,78P0FCgR01F8P03FC,78P07CgR03FQ01FE,78P03EgR07ER0FF,78P03EgR0F8R07F8,78P01FgQ01FS03F,78P01F8P01CIF78S03ES01F8,78Q0FQ08KF8S07CT0FC,78Q0F8KFEJ0RFCI01JF8T07E,78Q0F9KFEI07RFCI01JF8T03F,78Q0F9LF8007FEI0NFI01JFU01F,78Q0NF001FFK0MFI01IFEV0F8,78J03CK07FCI01F007F8K03EI01F8001EY0F8,78J07FK07FCJ0F00FEM06J0FD001EY07C,78J07F8J07F8J0FC1F8R07E001EY07C,78J07F8J07F8J0783FS03F001EY03F,78J07F8J07F8J07C7CS01F001EO07FFM03E,78J07F8J0FFK07CF8S01FC01EN01IFEL01E,78J07F8J0FFK03FFU0FC01EN07JFL01F8,78J07F8J0FEK03FEU07E01EN0KFCK01F8,78J07FK0FEK03FCU03E01EM01KFEL0F8,78J03EK0FEK01F8U01F01EM03LFL0F8,78P01FCK01F8V0F81EM07LF8K0F8,78P01FCK01FW0FE1EM07LF8K078,78P03FCL0EW07F1EM0MFCK078,78P07F8L0EL0EP03F1EM0MFCK07C,78P07F8L04K0FFEO01F3EL01MFEK07C,78P0FFR01IFO01FFEL01MFEK07C,78P0FFR07IF8O0FFEL03MFEK07C,78P03FR0JFCO07FEL03NFK07C,78Q0ER0JFEO03FEL03NFK07C,78Q06Q01JFEO01FEL03NFK07C,78gI01KF0EN0FEL03NFK07C,78gI03KFBEN0FEL03NFK07C,78gI03LFEN07EL03NFK07C,784K018004K01K083FF8N010083EK043NF040087C,784O0104002L087FFS01EK043NFJ087C,784008M084002L087FFM01L0EK043NFJ087C,784008M084003L087FFM01002I0E1J043MFEJ087C,7840083F004008410704I0187FFM0100303061J041MFE180187C,787FF87FF07KF0707JF87FF0MF0C1FF801JFE1MFE1IF87C,787FF87FF83KF0F87JF87FF07LF0C1FF801JFE1MFC1IF078,787FF87FF83KF0F83JF87FF07LF0E0FFC01JFE0MFC3IF0F8,787FF87FFC3JFE0F83JF87FF0MF0F07FE01JFE07LF83IF0F8,787FF87FFC3JFE0F83JF87FF0MF0F83FF01KF87LF83IF0F8,787FF87FFC3JFEI03JF83FFI03JF0F83FF81KF83LF07IF0F,787FF87FFC3JFEI01JF83FFJ0JF0FC1FFC1KFC1KFE0IFE1F8,787FF87FF83JFCI01JFC3FFJ0JF0FE0FFC1KFC0KFC1IFE1F8,787FF87FF83JFEI01JFC1FFJ0JF0FF07FE1KFE07JF83IFC1E,787FF87FF07SFE1JFC0JF0FF87FF1LF01IFE03IFC3E,787FF83FC0TFE0JFE1JF0FF83OFC07FF80JF83E,787FF8I01UF07IFC1JF0FFC1OFE007801JF87C,787FF8I03UF03IFC3JF0FFE0PFK03JF07C,787FFCI07UF81IF83JF0FBF07OFCJ0KF0FC,787FFC007VFC07FC07JF0F9F87JF1KF8007JFE0F8,787RFK07JFEK0KF0F8F83JF1LFCLFC1F,787RFK03KFJ01KF0F87C1JF0SFC3F8,787QFEK03KFCI07KF0F87E0JF07RF83E,787QFEK03LF803LF0F87F07IF03RF07E,787QFC1IFE1RF3FF0F81F07IF01QFE0FC,787QFC3IFE1FFDNFE1FF0F82F83IF00QFC1FC,787QF87IFE1FF87MF83FF0F817C1IF007PF83F,787QF87JF0FFC1MF03FF0F807E0IF001OFE07F,78NFE3FF87JF0FFC0LFC03FF0F807F0IF0C0OFC0FE,787KFE001FF0FE01F87FC01KF001FF0F805F07FF0E03NF81FC,78S0F80078K01IFM0F800F8J0F80MFC03F8,78R01FI078Q0EJ0F8007CJ0FC03LF00FF,78R01F8007CP03EJ0F8007EJ0FE007JFC01FE,7TFEI0MFJ01MF8003MF8003FFI07FF,7TFE8007MF001NF8001NFM01FF8,7TFEI03XF8001NFCL0FFE,7TFCI01XF8I07NF8J07FF8,7TFEI01XFJ03KF6JF01IFE8,gL0KF8W07NFC,gM01FCg0MFE4,hP04KFE4,hQ0KFE,,^FS\
      ^MMT\
      ^PW1181\
      ^LL827\
      ^LS0\
      ^FO653,668^GB145,83,2^FS\
      ^FO172,485^GB107,74,2^FS\
      ^FO652,585^GB146,79,2^FS\
      ^FT130,382^A0N,75,79^FH^CI28^FD${eliminarDiacriticos(dataToWrite.code)} ${eliminarDiacriticos(
        dataToWrite.description
      )}^FS^CI27\
      ^FO67,302^GB1038,115,2^FS\
      ^FT335,65^A0N,50,53^FH^CI28^FDDEVOLUCION DE FRUTAS^FS^CI27\
      ^FT411,194^A0N,33,38^FH^CI28^FDFECHA^FS^CI27\
      ^FT429,267^A0N,42,46^FH^CI28^FDGUIA:^FS^CI27\
      ^FT364,535^A0N,54,56^FH^CI28^FD${eliminarDiacriticos(dataToWrite.container.text)}^FS^CI27\
      ^FT126,643^A0N,50,53^FH^CI28^FD${dataToWrite.pallet_type}^FS^CI27\
      ^FT362,725^A0N,50,53^FH^CI28^FDPESO NETO^FS^CI27\
      ^FT671,728^A0N,50,53^FH^CI28^FD${dataToWrite.net_weight}^FS^CI27\
      ^FT359,644^A0N,50,53^FH^CI28^FDPESO BRUTO^FS^CI27\
      ^FT667,647^A0N,50,53^FH^CI28^FD${dataToWrite.gross_weight}^FS^CI27\
      ^FT815,732^A0N,50,53^FH^CI28^FDKILOS^FS^CI27\
      ^FT812,645^A0N,50,53^FH^CI28^FDKILOS^FS^CI27\
      ^FT189,545^A0N,50,53^FH^CI28^FD${dataToWrite.quantity}^FS^CI27\
      ^FT546,266^A0N,50,53^FH^CI28^FD${dataToWrite.company_waybill.number}^FS^CI27\
      ^FT497,132^A0N,46,51^FH^CI28^FDN ${pad(dataToWrite.product_return_id, 4)}^FS^CI27\
      ^FO920,0^BY4,2.0,65^BQ,2,6^FDQA,${eliminarDiacriticos(dataToWrite.number)}^FS\
      ^FT522,197^A0N,42,46^FH^CI28^FD${moment(dataToWrite.document_date).format("L")}^FS^CI27\
      ^PQ${numbrePrint},0,1,Y\
      ^CN
      ^XZ`,
      successCallback,
      errorCallback
    );
  }

  // CALIBRADO 300DPI
  if (typeLabel == "proceso-300dpi") {
    selected_device.send(
      `^XA
      ^MMT
      ^PW1181
      ^LL827
      ^LS0
      ^FO40,50^GFA,2904,2904,33,hR01FF,7OF8gY01LF,7OF8gY05LF,7PFgY0MFE4,7PFCgW07FFE03IFC,78M07FF8gV0FFCJ0IFC,78N07F8gU07FCL0FF8,78N01FEgT02FFM03FE,78O07FgT05FCN07F8,78O03FgS01FFO03FD,78P0FCgS0FEP0FE8,78P0FCgR01F8P03FC,78P07CgR03FQ01FE,78P03EgR07ER0FF,78P03EgR0F8R07F8,78P01FgQ01FS03F,78P01F8P01CIF78S03ES01F8,78Q0FQ08KF8S07CT0FC,78Q0F8KFEJ0RFCI01JF8T07E,78Q0F9KFEI07RFCI01JF8T03F,78Q0F9LF8007FEI0NFI01JFU01F,78Q0NF001FFK0MFI01IFEV0F8,78J03CK07FCI01F007F8K03EI01F8001EY0F8,78J07FK07FCJ0F00FEM06J0FD001EY07C,78J07F8J07F8J0FC1F8R07E001EY07C,78J07F8J07F8J0783FS03F001EY03F,78J07F8J07F8J07C7CS01F001EO07FFM03E,78J07F8J0FFK07CF8S01FC01EN01IFEL01E,78J07F8J0FFK03FFU0FC01EN07JFL01F8,78J07F8J0FEK03FEU07E01EN0KFCK01F8,78J07FK0FEK03FCU03E01EM01KFEL0F8,78J03EK0FEK01F8U01F01EM03LFL0F8,78P01FCK01F8V0F81EM07LF8K0F8,78P01FCK01FW0FE1EM07LF8K078,78P03FCL0EW07F1EM0MFCK078,78P07F8L0EL0EP03F1EM0MFCK07C,78P07F8L04K0FFEO01F3EL01MFEK07C,78P0FFR01IFO01FFEL01MFEK07C,78P0FFR07IF8O0FFEL03MFEK07C,78P03FR0JFCO07FEL03NFK07C,78Q0ER0JFEO03FEL03NFK07C,78Q06Q01JFEO01FEL03NFK07C,78gI01KF0EN0FEL03NFK07C,78gI03KFBEN0FEL03NFK07C,78gI03LFEN07EL03NFK07C,784K018004K01K083FF8N010083EK043NF040087C,784O0104002L087FFS01EK043NFJ087C,784008M084002L087FFM01L0EK043NFJ087C,784008M084003L087FFM01002I0E1J043MFEJ087C,7840083F004008410704I0187FFM0100303061J041MFE180187C,787FF87FF07KF0707JF87FF0MF0C1FF801JFE1MFE1IF87C,787FF87FF83KF0F87JF87FF07LF0C1FF801JFE1MFC1IF078,787FF87FF83KF0F83JF87FF07LF0E0FFC01JFE0MFC3IF0F8,787FF87FFC3JFE0F83JF87FF0MF0F07FE01JFE07LF83IF0F8,787FF87FFC3JFE0F83JF87FF0MF0F83FF01KF87LF83IF0F8,787FF87FFC3JFEI03JF83FFI03JF0F83FF81KF83LF07IF0F,787FF87FFC3JFEI01JF83FFJ0JF0FC1FFC1KFC1KFE0IFE1F8,787FF87FF83JFCI01JFC3FFJ0JF0FE0FFC1KFC0KFC1IFE1F8,787FF87FF83JFEI01JFC1FFJ0JF0FF07FE1KFE07JF83IFC1E,787FF87FF07SFE1JFC0JF0FF87FF1LF01IFE03IFC3E,787FF83FC0TFE0JFE1JF0FF83OFC07FF80JF83E,787FF8I01UF07IFC1JF0FFC1OFE007801JF87C,787FF8I03UF03IFC3JF0FFE0PFK03JF07C,787FFCI07UF81IF83JF0FBF07OFCJ0KF0FC,787FFC007VFC07FC07JF0F9F87JF1KF8007JFE0F8,787RFK07JFEK0KF0F8F83JF1LFCLFC1F,787RFK03KFJ01KF0F87C1JF0SFC3F8,787QFEK03KFCI07KF0F87E0JF07RF83E,787QFEK03LF803LF0F87F07IF03RF07E,787QFC1IFE1RF3FF0F81F07IF01QFE0FC,787QFC3IFE1FFDNFE1FF0F82F83IF00QFC1FC,787QF87IFE1FF87MF83FF0F817C1IF007PF83F,787QF87JF0FFC1MF03FF0F807E0IF001OFE07F,78NFE3FF87JF0FFC0LFC03FF0F807F0IF0C0OFC0FE,787KFE001FF0FE01F87FC01KF001FF0F805F07FF0E03NF81FC,78S0F80078K01IFM0F800F8J0F80MFC03F8,78R01FI078Q0EJ0F8007CJ0FC03LF00FF,78R01F8007CP03EJ0F8007EJ0FE007JFC01FE,7TFEI0MFJ01MF8003MF8003FFI07FF,7TFE8007MF001NF8001NFM01FF8,7TFEI03XF8001NFCL0FFE,7TFCI01XF8I07NF8J07FF8,7TFEI01XFJ03KF6JF01IFE8,gL0KF8W07NFC,gM01FCg0MFE4,hP04KFE4,hQ0KFE,,^FS\
      ^FO650,460^BY4,2.0,65^BQ,2,6^FDQA,${eliminarDiacriticos(dataToWrite.number)}^FS\
      ^FT762,83^A0N,42,46^FH\^CI28^FD${dataToWrite.process_data.number}^FS^CI27
      ^FT306,83^A0N,42,46^FH\^CI28^FD${dataToWrite.process_data.process_type} N^FS^CI27
      ^FT186,259^A0N,33,38^FH\^CI28^FDFECHA PROCESO:^FS^CI27
      ^FT187,203^A0N,33,38^FH\^CI28^FDFECHA RECEPCION:^FS^CI27
      ^FT331,145^A0N,42,46^FH\^CI28^FDPRODUCTO:^FS^CI27
      ^FT76,490^A0N,42,46^FH\^CI28^FD${dataToWrite.quantity}^FS^CI27
      ^FT341,421^A0N,50,53^FH\^CI28^FD${dataToWrite.manufacturing_order}^FS^CI27
      ^FT151,493^A0N,42,46^FH\^CI28^FD${eliminarDiacriticos(dataToWrite.container)}^FS^CI27
      ^FT159,422^A0N,50,53^FH\^CI28^FDOF:^FS^CI27
      ^FT59,739^A0N,50,53^FH\^CI28^FDLOTE:^FS^CI27
      ^FT213,740^A0N,50,53^FH\^CI28^FD${eliminarDiacriticos(dataToWrite.lot)} | N: ${dataToWrite.idx}^FS^CI27
      ^FT61,643^A0N,50,53^FH\^CI28^FDPESO NETO^FS^CI27
      ^FT369,645^A0N,50,53^FH\^CI28^FD${dataToWrite.net_kilograms}^FS^CI27
      ^FT59,570^A0N,50,53^FH\^CI28^FDPESO BRUTO^FS^CI27
      ^FT364,573^A0N,50,53^FH\^CI28^FD${dataToWrite.gross_kilograms}^FS^CI27
      ^FT476,645^A0N,50,53^FH\^CI28^FDKILOS^FS^CI27
      ^FT472,572^A0N,50,53^FH\^CI28^FDKILOS^FS^CI27
      ^FT585,149^A0N,50,53^FH\^CI28^FD${eliminarDiacriticos(dataToWrite.fruit)}^FS^CI27
      ^FT126,335^A0N,50,53^FH\^CI28^FD${eliminarDiacriticos(dataToWrite.product)}^FS^CI27
        ^FT511,254^A0N,33,38^FH\^CI28^FD${fechaBagno(dataToWrite.creation_date)}^FS^CI27
        ^FT511,201^A0N,33,38^FH\^CI28^FD${fechaBagno(dataToWrite.document_date)}^FS^CI27
        ^PQ${numbrePrint},0,1,Y
        ^CN
        ^XZ`,
      successCallback,
      errorCallback
    );
  }

  if (typeLabel == "proceso-203dpi") {
    selected_device.send(
      `^XA
      ^MMT
      ^PW799
      ^LL0559
      ^LS0
      
      ^FO50,50^GFA,936,936,18,,::0F82gJ07E,0KFCg07FFE,0E001FFY03F81FC,0CJ078X0F8001F,0CJ01CW01EJ078,0CK0EW038J01E,0CK07W0FL0F,0CK03V01CL078,0CK038L07CM018L01C,0CK019FFE00LFC03FFM01C,0CK01BFFE03F07IFE03FFN0E,0CK01F0060FI0700E038O07,0C007001E0071CL0703P03,0C007801E00338L0383P038,0C007801E003FM01C3K0FFI018,0C007001C003EN0E3J03FF80018,0C006003C001CN0E3J07FFC001C,0CK0380018N073J0IFEI0C,0CK078I08N03BJ0JFI0C,0CK078K01FCJ01FI01JFI0C,0CK03L03FEK0FI01JFI0C,0C8J01L07FFK0FI01JFI0C,0C8I0182022027FF320427I09JF104C,0C801E042402447C00J231009JF104C,0C8201024492447C0022J1009JF104C,0C820082489184FC00221281009JF20CC,0CA27C41A99014FCFFC24841008JF208C,0CBA7E5E69CBF4FC803245217F4IFE2E9C,0CBA7E5FD00BF47CIFA62A17F47FFE5E9C,0CBE7E5FD00FFE7C02FE71517FA3FFCFF18,0CBE7C5FF007FA7C02FE79E9IF1FF0FD38,0CFE70MFE3FE3FE7CKF87C1FF38,0CFE01IF81IF1FE7FE7C7JFC007FE3,0CFE07NF8787FE6E3FE7FF01FFC7,0CLFC003FFC00FFE671FE3LFCE2,0CLFC001IF03FFE639FF1LF8E,0CLFCFF9F7JF3E61CFF0LF1C,0CLF8FF9F1IFC3E60C7F07JFE38,0CIFE0F9C18F87FF03E60E3F23JF87,0CL0181CI03010060700307FFE1E,0CJ080380C01800700603803C0FF03C,0NF80JF07IFE01JFJ0F8,0NF00OFE01JFE00FE,T01FFK08I01JF8,gH04J07FFC04,gG082N01,T02008N02J04,gM07002,,^FS\
      
      ^FO500,250^BY4,2.0,65^BQ,2,6^FDQA,${eliminarDiacriticos(dataToWrite.number)}^FS
      
      ^FT515,56^A0N,28,28^FH^FD${dataToWrite.process_data.number}^FS
      ^FT207,56^A0N,28,28^FH^FD${dataToWrite.process_data.process_type}  N\F8^FS
      ^FT126,176^A0N,23,24^FH^FDFECHA PROCESO:^FS
      ^FT126,138^A0N,23,24^FH^FDFECHA RECEPCION:^FS
      ^FT224,98^A0N,28,28^FH^FDPRODUCTO:^FS
      ^FT52,331^A0N,28,28^FH^FD${dataToWrite.quantity}^FS
      ^FT231,285^A0N,34,33^FH^FD${dataToWrite.manufacturing_order}^FS
      ^FT102,333^A0N,28,28^FH^FD${eliminarDiacriticos(dataToWrite.container)}^FS
      ^FT107,286^A0N,34,33^FH^FDOF:^FS
      ^FT114,500^A0N,34,33^FH^FDLOTE:^FS
      ^FT212,501^A0N,34,33^FH^FD${eliminarDiacriticos(dataToWrite.lot)} | N: ${dataToWrite.idx}^FS
      ^FT41,435^A0N,34,33^FH^FDPESO NETO^FS
      ^FT250,437^A0N,34,33^FH^FD${dataToWrite.net_kilograms}^FS
      ^FT40,386^A0N,34,33^FH^FDPESO BRUTO^FS
      ^FT246,388^A0N,34,33^FH^FD${dataToWrite.gross_kilograms}^FS
      ^FT352,437^A0N,34,33^FH^FDKILOS^FS
      ^FT350,387^A0N,34,33^FH^FDKILOS^FS
      ^FT396,101^A0N,34,33^FH^FD${eliminarDiacriticos(dataToWrite.fruit)}^FS
      ^FT86,227^A0N,34,33^FH^FD${eliminarDiacriticos(dataToWrite.product)}^FS
      ^FT346,172^A0N,23,24^FH^FD${fechaBagno(dataToWrite.creation_date)}^FS
      ^FT346,137^A0N,23,24^FH^FD${fechaBagno(dataToWrite.document_date)}^FS
      ^PQ${numbrePrint},0,1,Y^XZ`,
      successCallback,
      errorCallback
    );
  }

  // ENMALLADO 300DPI
  if (typeLabel == "enmallado-300dpi") {
    selected_device.send(
      `^XA
      ^MMT
      ^PW1181
      ^LL827
      ^LS0
      ^FO40,50^GFA,2904,2904,33,hR01FF,7OF8gY01LF,7OF8gY05LF,7PFgY0MFE4,7PFCgW07FFE03IFC,78M07FF8gV0FFCJ0IFC,78N07F8gU07FCL0FF8,78N01FEgT02FFM03FE,78O07FgT05FCN07F8,78O03FgS01FFO03FD,78P0FCgS0FEP0FE8,78P0FCgR01F8P03FC,78P07CgR03FQ01FE,78P03EgR07ER0FF,78P03EgR0F8R07F8,78P01FgQ01FS03F,78P01F8P01CIF78S03ES01F8,78Q0FQ08KF8S07CT0FC,78Q0F8KFEJ0RFCI01JF8T07E,78Q0F9KFEI07RFCI01JF8T03F,78Q0F9LF8007FEI0NFI01JFU01F,78Q0NF001FFK0MFI01IFEV0F8,78J03CK07FCI01F007F8K03EI01F8001EY0F8,78J07FK07FCJ0F00FEM06J0FD001EY07C,78J07F8J07F8J0FC1F8R07E001EY07C,78J07F8J07F8J0783FS03F001EY03F,78J07F8J07F8J07C7CS01F001EO07FFM03E,78J07F8J0FFK07CF8S01FC01EN01IFEL01E,78J07F8J0FFK03FFU0FC01EN07JFL01F8,78J07F8J0FEK03FEU07E01EN0KFCK01F8,78J07FK0FEK03FCU03E01EM01KFEL0F8,78J03EK0FEK01F8U01F01EM03LFL0F8,78P01FCK01F8V0F81EM07LF8K0F8,78P01FCK01FW0FE1EM07LF8K078,78P03FCL0EW07F1EM0MFCK078,78P07F8L0EL0EP03F1EM0MFCK07C,78P07F8L04K0FFEO01F3EL01MFEK07C,78P0FFR01IFO01FFEL01MFEK07C,78P0FFR07IF8O0FFEL03MFEK07C,78P03FR0JFCO07FEL03NFK07C,78Q0ER0JFEO03FEL03NFK07C,78Q06Q01JFEO01FEL03NFK07C,78gI01KF0EN0FEL03NFK07C,78gI03KFBEN0FEL03NFK07C,78gI03LFEN07EL03NFK07C,784K018004K01K083FF8N010083EK043NF040087C,784O0104002L087FFS01EK043NFJ087C,784008M084002L087FFM01L0EK043NFJ087C,784008M084003L087FFM01002I0E1J043MFEJ087C,7840083F004008410704I0187FFM0100303061J041MFE180187C,787FF87FF07KF0707JF87FF0MF0C1FF801JFE1MFE1IF87C,787FF87FF83KF0F87JF87FF07LF0C1FF801JFE1MFC1IF078,787FF87FF83KF0F83JF87FF07LF0E0FFC01JFE0MFC3IF0F8,787FF87FFC3JFE0F83JF87FF0MF0F07FE01JFE07LF83IF0F8,787FF87FFC3JFE0F83JF87FF0MF0F83FF01KF87LF83IF0F8,787FF87FFC3JFEI03JF83FFI03JF0F83FF81KF83LF07IF0F,787FF87FFC3JFEI01JF83FFJ0JF0FC1FFC1KFC1KFE0IFE1F8,787FF87FF83JFCI01JFC3FFJ0JF0FE0FFC1KFC0KFC1IFE1F8,787FF87FF83JFEI01JFC1FFJ0JF0FF07FE1KFE07JF83IFC1E,787FF87FF07SFE1JFC0JF0FF87FF1LF01IFE03IFC3E,787FF83FC0TFE0JFE1JF0FF83OFC07FF80JF83E,787FF8I01UF07IFC1JF0FFC1OFE007801JF87C,787FF8I03UF03IFC3JF0FFE0PFK03JF07C,787FFCI07UF81IF83JF0FBF07OFCJ0KF0FC,787FFC007VFC07FC07JF0F9F87JF1KF8007JFE0F8,787RFK07JFEK0KF0F8F83JF1LFCLFC1F,787RFK03KFJ01KF0F87C1JF0SFC3F8,787QFEK03KFCI07KF0F87E0JF07RF83E,787QFEK03LF803LF0F87F07IF03RF07E,787QFC1IFE1RF3FF0F81F07IF01QFE0FC,787QFC3IFE1FFDNFE1FF0F82F83IF00QFC1FC,787QF87IFE1FF87MF83FF0F817C1IF007PF83F,787QF87JF0FFC1MF03FF0F807E0IF001OFE07F,78NFE3FF87JF0FFC0LFC03FF0F807F0IF0C0OFC0FE,787KFE001FF0FE01F87FC01KF001FF0F805F07FF0E03NF81FC,78S0F80078K01IFM0F800F8J0F80MFC03F8,78R01FI078Q0EJ0F8007CJ0FC03LF00FF,78R01F8007CP03EJ0F8007EJ0FE007JFC01FE,7TFEI0MFJ01MF8003MF8003FFI07FF,7TFE8007MF001NF8001NFM01FF8,7TFEI03XF8001NFCL0FFE,7TFCI01XF8I07NF8J07FF8,7TFEI01XFJ03KF6JF01IFE8,gL0KF8W07NFC,gM01FCg0MFE4,hP04KFE4,hQ0KFE,,^FS\
      ^FO650,460^BY4,2.0,65^BQ,2,6^FDQA,${eliminarDiacriticos(dataToWrite.number)}^FS\
      ^FT104,277^A0N,58,61^FH\^CI28^FD${eliminarDiacriticos(dataToWrite.product_code)} ${eliminarDiacriticos(
        dataToWrite.product
      )}^FS^CI27
      ^FT526,77^A0N,42,46^FH\^CI28^FDENMALLADO N ${dataToWrite.process_data.number}^FS^CI27
      ^FT325,76^A0N,42,46^FH\^CI28^FDPROCESO:^FS^CI27
      ^FT435,128^A0N,33,38^FH\^CI28^FDFECHA^FS^CI27
      ^FT278,189^A0N,42,46^FH\^CI28^FDORDEN FABRICACION:^FS^CI27
      ^FT156,382^A0N,58,61^FH\^CI28^FDLOTE:^FS^CI27
      ^FT311,380^A0N,58,61^FH\^CI28^FD${eliminarDiacriticos(dataToWrite.lot)} | N: ${dataToWrite.idx}^FS^CI27
      ^FT97,539^A0N,42,46^FH\^CI28^FDFORMATO:^FS^CI27
      ^FT195,456^A0N,42,46^FH\^CI28^FD${eliminarDiacriticos(dataToWrite.container)}^FS^CI27
      ^FT64,727^A0N,50,53^FH\^CI28^FDPESO NETO^FS^CI27
      ^FT389,729^A0N,50,53^FH\^CI28^FD${dataToWrite.net_kilograms}^FS^CI27
      ^FT63,631^A0N,50,53^FH\^CI28^FDPESO BRUTO^FS^CI27
      ^FT377,629^A0N,50,53^FH\^CI28^FD${dataToWrite.gross_kilograms}^FS^CI27
      ^FT546,731^A0N,50,53^FH\^CI28^FDKILOS^FS^CI27
      ^FT546,632^A0N,50,53^FH\^CI28^FDKILOS^FS^CI27
      ^FT106,462^A0N,42,46^FH\^CI28^FD${dataToWrite.quantity}^FS^CI27
      ^FT704,187^A0N,42,46^FH\^CI28^FD${pad(dataToWrite.manufacturing_order, 4)}^FS^CI27
      ^FT316,542^A0N,42,46^FH\^CI28^FD${dataToWrite.units_per_container}Un x ${dataToWrite.kg_per_unit}Kg^FS^CI27
      ^FT552,127^A0N,33,38^FH\^CI28^FD${fechaBagno(dataToWrite.creation_date)}^FS^CI27
      ^PQ${numbrePrint},0,1,Y
      ^CN
      ^XZ`,
      successCallback,
      errorCallback
    );
  }
}

export function PrintLabel(zpl_code, labelQty) {
  let code = zpl_code.replace("$$quantity$$", labelQty);
  selected_device.send(code, successCallback, errorCallback);
}

export function Printer(dataToWrite, typeLabel, numbrePrint) {
  //Etiqueta 4x6 pulgadas
  if (typeLabel == 1) {
    selected_device.send(
      "^XA\
        ^FX Top section with company logo, name and address.\
        ^CF0,60\
        ^FO50,135^FD" +
        eliminarDiacriticos(dataToWrite.product_name) +
        "^FS\
        ^FO50,195^FD" +
        eliminarDiacriticos(dataToWrite.variety_name) +
        "^FS\
        ^CF0,40\
        ^FO50,250^GB700,1,3^FS\
        ^FX Second section with recipient address and permit information.\
        ^CFA,30\
        ^FO50,265^FDLote: " +
        eliminarDiacriticos(dataToWrite.lot_number) +
        "^FS\
        ^FO50,305^FDProductor: " +
        eliminarDiacriticos(dataToWrite.origin_name) +
        "(" +
        dataToWrite.origin_code +
        ")^FS\
        ^FO50,340^FDGuia de despacho: " +
        dataToWrite.waybill_number +
        "^FS\
        ^FO50,380^FDFecha de recepcion: " +
        dataToWrite.waybill_date +
        "^FS\
        ^FO50,420^FD" +
        eliminarDiacriticos(dataToWrite.client_customer_name) +
        "^FS\
        ^FO50,460^FDTipo producto: " +
        eliminarDiacriticos(dataToWrite.product_type_name) +
        "^FS\
        ^CFA,15\
        ^FO50,500^GB700,1,3^FS\
        ^FX Fourth section (the two boxes on the bottom).\
        ^FO50,800^GB700,150,3^FS\
        ^FO400,800^GB1,150,3^FS\
        ^CF0,40\
        ^FO50,670^FD" +
        eliminarDiacriticos2(dataToWrite.container_name) +
        ".^FS\
        ^FO50,750^FDUnidades:" +
        dataToWrite.quantity +
        "^FS\
        ^FO500,900^BY4,2.0,65^BQ,2,7^FDQA," +
        dataToWrite.pallet_number +
        "^FS\
        ^CF0,40\
        ^FO80,815^FDKG BRUTOS^FS\
        ^FO425,815^FDKG NETOS^FS\
        ^CF0,80\
        ^FO425,860^FD" +
        dataToWrite.net_kilograms +
        "^FS\
        ^FO80,860^FD" +
        dataToWrite.gross_kilograms +
        "^FS\
        ^CF0,75\
        ^FO50,520^FD" +
        eliminarDiacriticos(dataToWrite.condition) +
        "^FS\
        ^CF0,130\
        ^FO50,30^FD" +
        dataToWrite.pallet_number +
        "^FS\
        ^PQ" +
        numbrePrint +
        "\
        ^XZ",
      undefined,
      errorCallback
    );
  }

  //Etiqueta 4x3 pulgadas
  if (typeLabel == 2) {
    var waybill_date = formato(dataToWrite.waybill_date);

    selected_device.send(
      "^XA\
    ^FX Top section with company logo, name and address.\
    ^CF0,60\
    ^FO50,50^FDPALLET: " +
        dataToWrite.pallet_number +
        "^FS\
    ^CF0,40\
    ^FO50,100^FD" +
        eliminarDiacriticos(dataToWrite.variety_name) +
        " - " +
        eliminarDiacriticos(dataToWrite.product_name) +
        "^FS\
    ^FO50,144^FD" +
        eliminarDiacriticos(dataToWrite.origin_name) +
        " (" +
        dataToWrite.origin_code +
        ")^FS\
    ^FO50,190^GB700,1,3^FS\
    ^FX Second section with recipient address and permit information QR.\
    ^FO650,50^BY4,2.0,20^BQ,2,5^FDQA," +
        dataToWrite.pallet_number +
        "^FS\
    ^CFA,30\
    ^FO50,210^FDLOTE: " +
        dataToWrite.lot_number +
        " | " +
        eliminarDiacriticos(dataToWrite.condition) +
        "^FS\
    ^CFA,22\
    ^FO50,270^FDGUIA:" +
        dataToWrite.waybill_number +
        "^FS\
    ^FO50,310^FDKB:" +
        dataToWrite.gross_kilograms +
        "^FS\
    ^FO50,350^FDKN:" +
        dataToWrite.net_kilograms +
        "^FS\
    ^FO50,390^FDFECHA:" +
        waybill_date +
        "^FS\
    ^FO50,430^FDUNIDADES:" +
        dataToWrite.quantity +
        "^FS\
    ^FO380,270^FDEXP:" +
        eliminarDiacriticos(dataToWrite.client_customer_name) +
        "^FS\
    ^FO380,310^FDTIPO PRODUCTO: " +
        eliminarDiacriticos(dataToWrite.product_type_name) +
        "^FS\
    ^FO380,350^FDVARIEDAD:" +
        eliminarDiacriticos(dataToWrite.variety_name) +
        "^FS\
    ^FO380,390^FDSPECS:" +
        eliminarDiacriticos(dataToWrite.string_specs) +
        "^FS\
    ^FO380,430^FDRECIPIENTE:" +
        eliminarDiacriticos2(dataToWrite.container_name) +
        "^FS\
    ^PQ" +
        numbrePrint +
        "\
    ^CFA,15\
    ^XZ",
      successCallback,
      errorCallback
    );
  }

  //Bodega
  if (typeLabel == 3) {
    var waybill_date = formato(dataToWrite.waybill_date);

    selected_device.send(
      "^XA\
          ^FX Top section with company logo, name and address.\
          ^CF0,80\
          ^FO650,80^FD" +
        dataToWrite.supply_family +
        "^FS\
          ^CF0,60\
          ^FO30,50^FD" +
        eliminarDiacriticos(dataToWrite.supply_name) +
        "^FS\
          ^FO30,230^FDCantidad: " +
        dataToWrite.quantity +
        "^FS\
          ^CF0,30\
          ^FO30,110^FDExp: " +
        eliminarDiacriticos(dataToWrite.client_customer_name) +
        "^FS\
          ^FO30,145^FDProv: " +
        eliminarDiacriticos(dataToWrite.company_name) +
        "^FS\
          ^FO30,175^FDGD: " +
        dataToWrite.waybill_number +
        " - " +
        waybill_date +
        "^FS\
          ^FO50,210^GB700,1,3^FS\
          ^FX Third section with barcode.\
          ^BY3,2,150\
          ^FO30,290^BC^FD" +
        dataToWrite.supply_lot +
        "^FS\
          ^PQ" +
        numbrePrint +
        "\
          ^XZ",
      successCallback,
      errorCallback
    );
  }

  if (typeLabel == 4) {
    var waybill_date = formato(dataToWrite.waybill_date);

    selected_device.send(
      "^XA\
      ^CF0,250\
      ^FO550,100^A0R^FD" +
        dataToWrite.pallet_number +
        "^FS\
      ^CF0,70\
      ^FO560,20^A0R^FDProductor:\
      ^CF0,120\
      ^FO440,20^A0R^FD" +
        eliminarDiacriticos(dataToWrite.origin_short_name) +
        "(" +
        dataToWrite.origin_code +
        ")^FS\
      ^FO300,20^A0R^FD" +
        eliminarDiacriticos(dataToWrite.product_name) +
        " - " +
        eliminarDiacriticos(dataToWrite.variety_name) +
        "^FS\
      ^CF0,60\
      ^FO210,20^A0R^FDFecha de recepcion: " +
        waybill_date +
        "^FS\
      ^CF0,50\
      ^CFA,15\
      ^FX Fourth section (the one boxes on the bottom).\
      ^FO20,20^GB150,700,3^FS\
      ^CF0,40\
      ^FO110,50^A0R^FDKG NETOS^FS\
      ^CF0,90\
      ^FO50,280^A0R^FD" +
        dataToWrite.net_kilograms +
        "^FS\
      ^FO50,920^A0R^FDG:" +
        dataToWrite.waybill_number +
        "^FS\
      ^PQ" +
        numbrePrint +
        "\
      ^XZ",
      successCallback,
      errorCallback
    );
  }

  //Etiqueta 10x15 V(UN)
  if (typeLabel == 5) {
    selected_device.send(
      "^XA\
        ^FX Top section with company logo, name and address.\
        ^CF0,60\
        ^FO50,135^FD" +
        eliminarDiacriticos(dataToWrite.product_name) +
        "^FS\
        ^FO50,195^FD" +
        eliminarDiacriticos(dataToWrite.variety_name) +
        "^FS\
        ^CF0,40\
        ^FO50,250^GB700,1,3^FS\
        ^FX Second section with recipient address and permit information.\
        ^CFA,30\
        ^FO50,265^FDLote: " +
        eliminarDiacriticos(dataToWrite.lot_number) +
        "^FS\
        ^FO50,305^FDProductor: " +
        eliminarDiacriticos(dataToWrite.origin_name) +
        "(" +
        dataToWrite.origin_code +
        ")^FS\
        ^FO50,340^FDGuia de despacho: " +
        dataToWrite.waybill_number +
        "^FS\
        ^FO50,380^FDFecha de recepcion: " +
        dataToWrite.waybill_date +
        "^FS\
        ^FO50,420^FD" +
        eliminarDiacriticos(dataToWrite.client_customer_name) +
        "^FS\
        ^FO50,460^FDTipo producto: " +
        eliminarDiacriticos(dataToWrite.product_type_name) +
        "^FS\
        ^CFA,15\
        ^FO50,500^GB700,1,3^FS\
        ^CF0,40\
        ^FO50,670^FD" +
        eliminarDiacriticos2(dataToWrite.container_name) +
        ".^FS\
        ^FO50,750^FDENVASES:" +
        dataToWrite.quantity +
        "^FS\
        ^FO500,900^BY4,2.0,65^BQ,2,7^FDQA," +
        dataToWrite.pallet_number +
        "^FS\
        ^CF0,40\
        ^FO50,815^FDUN: " +
        dataToWrite.net_kilograms +
        "^FS\
        ^CF0,75\
        ^FO50,520^FD" +
        eliminarDiacriticos(dataToWrite.condition) +
        "^FS\
        ^CF0,130\
        ^FO50,30^FD" +
        dataToWrite.pallet_number +
        "^FS\
        ^PQ" +
        numbrePrint +
        "\
        ^XZ",
      undefined,
      errorCallback
    );
  }

  //10x15 Landscape (P)
  if (typeLabel == 6) {
    selected_device.send(
      "^XA\
    ^FO640,40^GB120,1100,3^FS\
    ^CF0,100\
    ^FO640,50^A0R^FD GUIA:" +
        dataToWrite.waybill_number +
        "^FS\
    ^CF0,120\
    ^FO500,20^A0R^FD FOLIO: " +
        dataToWrite.pallet_number +
        "^FS\
    ^CF0,80\
    ^FO420,20^A0R^FD ESPECIE:" +
        eliminarDiacriticos(dataToWrite.product_name) +
        "^FS\
    ^FO340,20^A0R^FD VARIEDAD:" +
        eliminarDiacriticos(dataToWrite.variety_name) +
        "^FS\
    ^FO260,20^A0R^FD FECHA RECEPCION:" +
        dataToWrite.waybill_date +
        "^FS\
    ^CF0,60\
    ^FO180,20^A0R^FD CSG:" +
        dataToWrite.origin_code +
        "-" +
        eliminarDiacriticos(dataToWrite.origin_province) +
        "-" +
        eliminarDiacriticos(dataToWrite.origin_township) +
        "^FS\
    ^FO100,20^A0R^FD PLANTAS X CAJON:" +
        dataToWrite.net_kilograms +
        "^FS\
    ^FO20,20^A0R^FD" +
        eliminarDiacriticos(dataToWrite.string_specs) +
        "^FS\
    ^PQ" +
        numbrePrint +
        "\
    ^XZ",
      undefined,
      errorCallback
    );
  }

  //Etiqueta 10x15 V(UN-C)
  if (typeLabel == 7) {
    selected_device.send(
      "^XA\
        ^FX Top section with company logo, name and address.\
        ^CF0,60\
        ^FO50,135^FD" +
        eliminarDiacriticos(dataToWrite.product_name) +
        "^FS\
        ^FO50,195^FD" +
        eliminarDiacriticos(dataToWrite.variety_name) +
        "^FS\
        ^CF0,40\
        ^FO50,250^GB700,1,3^FS\
        ^FX Second section with recipient address and permit information.\
        ^CFA,30\
        ^FO50,265^FDLote: " +
        eliminarDiacriticos(dataToWrite.lot_number) +
        "^FS\
        ^FO50,305^FDProductor: " +
        eliminarDiacriticos(dataToWrite.origin_name) +
        "(" +
        dataToWrite.origin_code +
        ")^FS\
        ^FO50,340^FDGuia de despacho: " +
        dataToWrite.waybill_number +
        "^FS\
        ^FO50,380^FDFecha de recepcion: " +
        dataToWrite.waybill_date +
        "^FS\
        ^FO50,420^FD" +
        eliminarDiacriticos(dataToWrite.client_customer_name) +
        "^FS\
        ^FO50,460^FDTipo producto: " +
        eliminarDiacriticos(dataToWrite.product_type_name) +
        "^FS\
        ^CFA,15\
        ^FO50,500^GB700,1,3^FS\
        ^CF0,40\
        ^FO50,670^FD" +
        eliminarDiacriticos2(dataToWrite.container_name) +
        ".^FS\
        ^FO50,750^FDENVASES:" +
        dataToWrite.quantity +
        "^FS\
        ^FO500,900^BY4,2.0,65^BQ,2,7^FDQA," +
        dataToWrite.pallet_number +
        "^FS\
        ^CF0,40\
        ^FO50,815^FDUN: " +
        dataToWrite.net_kilograms +
        "^FS\
        ^FO50,875^FDCLASF: " +
        eliminarDiacriticos(dataToWrite.classification) +
        "^FS\
        ^CF0,75\
        ^FO50,520^FD" +
        eliminarDiacriticos(dataToWrite.condition) +
        "^FS\
        ^CF0,130\
        ^FO50,30^FD" +
        dataToWrite.pallet_number +
        "^FS\
        ^PQ" +
        numbrePrint +
        "\
        ^XZ",
      undefined,
      errorCallback
    );
  }

  //Etiqueta 10x15 Guia de Materiales
  if (typeLabel == 8) {
    selected_device.send(
      "^XA\
            ^FX Top section with company logo, name and address.\
            ^CF0,60\
            ^FO50,100^FDMaterial^FS\
            ^CF0,40\
            ^FO50,170^FD" +
        dataToWrite.waybill_date +
        "^FS\
            ^CF0,40\
            ^FO50,250^GB700,1,3^FS\
            ^FX Second section with recipient address and permit information.\
            ^CFA,40\
            ^FO50,270^FD" +
        eliminarDiacriticos(dataToWrite.supply.text) +
        "^FS\
            ^FO50,330^FD" +
        eliminarDiacriticos(dataToWrite.supply.code) +
        "^FS\
            ^FO50,390^FD" +
        eliminarDiacriticos(dataToWrite.supply.unit) +
        "^FS\
            ^FO50,450^FDCantidad " +
        dataToWrite.quantity +
        "^FS\
            ^FO50,510^FDLOT " +
        eliminarDiacriticos(dataToWrite.lot) +
        "^FS\
            ^FO50,570^FDPALLET " +
        eliminarDiacriticos(dataToWrite.number) +
        "^FS\
            ^FX Coidgo QR.\
            ^FO50,620^GB700,1,3^FS\
            ^FO330,580^BY5,3.0,65^BQ,2,9^FDQA," +
        eliminarDiacriticos(dataToWrite.pallet_id) +
        "^FS\
            ^CF0,130\
            ^PQ" +
        numbrePrint +
        "\
            ^XZ",
      successCallback,
      errorCallback
    );
  }

  //   ^XA
  // ^FO50,50^GFA,6336,6336,36,,::::::gU0F8,gT0JF,gR0203IF8,gQ01E03JF,gQ07601JF8,gP01FE00JFE,gP01CE00KF,gP0F0E007IFE,gO037F6003JF,gO0400A001JF8,gO0C00AI0JFC,gN03900EI0JFC,gN03300EI07IFC,gN0CE00EI03IFC,gN0F900EI01IF,gM01F300FJ0IFC,gM030600FJ0IFE,gM05J01J07FFC,:gL01C002078I03FFC,gL019002038I01FFC,gL011002038I01FFC,gL03200207CJ0FFC,gL0320060FCJ0FFC,gL07A0060FCJ0FFC,gL0190030FCJ07F,gL0390039FEJ07F,gL0390073FEJ03F,gL0F30063FFJ03F,gK01EF0027FFJ03F,gK01CEI07FFJ03F4,gK018E008IF8I01F4,gK018E009IF8I01F4,gK01I0C3IFCI01FC,gK0300C23IFEJ0FC,gK0300C07IFEJ0FC,gK030080KFJ0FC,gK020081KF8I0FC,gK02I03KFCI0FC,gK03I07KFEI0F4,gK03I0MFI074,gK021C3MF8005C,gK02807MFE007C,gK0280OF803E,gK0207OFE02C,gK020QFC,gK023RFC,gK037SF,gK03UF8,gK03VF8,gK03WFC,gK03YF,gK01YF8,:gK01YF,gL0YF,:gL07WFE,:gL03WFC,:gL01WF8,:gM0WF,:gM07UFE,gM03UFC,gM01UFC,gM01UF8,gN0UF,gN07SFE,gN03SFC,gN01SF8,gO07RF,gO03QFC,gO01QF8,gP07OFE,gP03OFC,gQ0OF,gQ03MFC,gR0LFE,gR01KF,gT07FC,,:::::::::::::hS08,K01K03C007F8N0FgK03C,K03K07C03FFCM01FgK03E,K038J07C07FFCM01FgK03C,K078J07C0IFCM01FgK018,K07CJ07E1FFO01F,K07CJ07E1F8O01F,K0FCJ07E1FP01FgP03F8J0KFE,K0FEJ07E3FN0801IFEK03FFE007C7FF1F1FFC3E001IF8001KFE,J01FEJ07E3EJ03IFE01JF8J0JF807CIF9F3FFE3E007JF007KFE,J01FFJ07E3EJ0JFE01JFEI01JFE07PFBE00KF807KFE,J019FJ07E3EI03JFE01KF8007KF07QFE01FF0FFC0LFE,J039FJ07E3EI07JFE01F81FFC00FF00FF87FE07IF81FFE03F801FE0FC,J030F8I07E3IF0FF803E01F001FE00FC003FC7F801FFE0073E07EI07F0F8,J070F8I07E3IF9FC003E01FI07F01F8I0FC7FI01FCI03E0FCI03F1F,J060FCI07E3IF9F8003E01FI03F03FJ07E7EI01F8I03E0F8I01F1F,J0E07CI07E3IFBFI03E01FI01F83EJ07E7EI01F8I03E1FJ01F9F,J0E07EI07E3IF7EI03E01FJ0F87CJ03E7CI01FJ03E1FK0F8F8,I01C03EI07E3E007CI03E01FJ0FC7CJ03F7CI01FJ03E3EK0F8FE1,I01C03FI07E3E007CI03E01FJ07C78J03F7CI01FJ03E3EJ01F8LF,I01803FI07E3E0078I03E01FJ07C783KF7CI01FJ03E3E1KF87KF8,I03801FI07E3E00F8I03E01FJ07CF87KF7CI01FJ03E3C1KFC3KFE,I03001F8007E3E00F8I03E01FJ07CF87KF7CI01FJ03E3C1KF81KFE,I07I0F8007E3E00F8I03E01FJ07CF87KF7CI01FJ03E3C1IFE2L0FF,I07JFC007E3E00F8I03E01FJ07C78L07CI01FJ03E3ER03F,I07JFC007E3E00F8I03E01FJ07C78L07CI01FJ03E3ER01F,I0EI07C007E3E007CI03E01FJ0FC78L07CI01FJ03E3ES0F8,I0CI07E007E3E007CI03E01FJ0FC7CL07CI01FJ03E1FK04M0F8,001CI03E007E3E007CI03E01FI01F83EJ0187CI01FJ03E1FK0EM0F8,0018I03F007E3E003EI03E01FI01F83EJ03C7CI01FJ03E0F8I01FL01F8,0038I01F007E3E003FI03E01FI07F01FJ07C7CI01FJ03E0FEI03FL03F,0038I01F807E3E001F8003E01FI0FE01FC001FC7CI01FJ03E07FI0FEL0FF,007K0F807E3EI0FE003E00F003FC00FE007F87CI01FJ03E03FE0FFC0LFE,007K0FC07E3EI0FF87BE01KF8007KF07CI01FJ03E01KF80LFE,006K0FC07E3EI07IFBE01KFI03JFE07CI01FJ03E00KF00LFC,00FK0FE07E3EI01IFBE01JFEJ0JFC07CI01FJ03E003IFC00LF,01FJ01FF07E3EJ0IF3E00JFK03FFE007CI01FJ03EI07FEI07C,07FEI07FFC3E3EJ01FE1C00FAEM0FF,Q024,,:::::::::::::hJ0210010010FA0F8,T0180102008FE0181FE00FF18180FE1FE3FE3FE31FE18C,T0EF030201CC701C18300C01C180831803033033180306,S0183078201C8183418180C01E1808118030330331803,S0181048201C8082618180C01A18083180303303318038,S01I0C8201C80C6618180C013180C618030630631C41F,S03I0CC201C80C6318180FF11980FF1FE3FC3FC31FE03C,S03I0CC201C80C6318180C0199808318031831C318I06,S03001FE201C80CFF18180C018D808198030C30C3180206,S01011FE201C808C118180C018780819803063063180306,S0181903201CC188198300C01838081980303303318038E,T0C3303301CC71809FE00FF98380FF1FF30330331FF1F8,T0FE3013F88FEI08C,T018,,::::^FS\
  //  ^FX Top section with company logo, name and address.\
  //         ^CF0,60\
  //         ^FO450,100^FDMaterial^FS\
  //         ^CF0,40\
  //         ^FO440,170^FD20-09-2020^FS\
  //         ^CF0,40\
  //         ^FO50,250^GB700,1,3^FS\
  //         ^FX Second section with recipient address and permit information.\
  //         ^CFA,40\
  //         ^FO50,270^FDCaja 6oz Luis Pelayo ^FS\
  //         ^FO50,330^FD4001^FS\
  //         ^FO50,390^FDUn^FS\
  //         ^FO50,450^FDCantidad 20^FS\
  //         ^FO50,510^FDLOT 18285620-30092020-4001^FS\
  //         ^FO50,570^FDPALLET 1601475702633P1^FS\
  //         ^FX Coidgo QR.\
  //         ^FO50,620^GB700,1,3^FS\
  //         ^FO330,580^BY5,3.0,65^BQ,2,9^FDQA,20000^FS\
  //         ^CF0,130\
  //         ^PQ" + numbrePrint + "\
  //         ^XZ

  //Etiqueta 4x3 pulgadas P(PLANT)
  /*
  if (typeLabel == 6) {

    selected_device.send("^XA\
    ^FX Top section with company logo, name and address.\
    ^CFA,30\
    ^FO340,20^GB440,95,3^FS\
    ^FO520,35^FDGUIA^FS\
    ^CF0,50\
    ^FO0,70^A0N,40,40^FB1110,1,0,C^FD" + dataToWrite.waybill_number + "^FS \
    ^FO50,200^GB700,1,3^FS\
    ^CF0,60\
    ^FO50,140^FDFOLIO:"+dataToWrite.pallet_number+"^FS\
    ^CFA,30\
    ^FO50,230^FDESPECIE:" + eliminarDiacriticos(dataToWrite.product_name) + "^FS\
    ^FO50,270^FD" + eliminarDiacriticos(dataToWrite.variety_name) + "^FS\
    ^FO50,310^FDFECHA^FS\
    ^FO50,340^FDRECEPCION^FS\
    ^FO240,320^FD" + dataToWrite.waybill_date + "^FS\
    ^CFA,30\
    ^FO50,380^FDCSG:" + eliminarDiacriticos(dataToWrite.origin_name) + "(" + dataToWrite.origin_code + ")^FS\
    ^CFA,30\
    ^FO340,430^GB440,160,3^FS\
    ^FO430,450^FDPLANTAS X CAJON^FS\
    ^CF0,50\
    ^FO0,490^A0N,50,50^FB1110,1,0,C^FD" + dataToWrite.net_kilograms + "^FS \
    ^CFA,30\
    ^FO0,550^A0N,25,25^FB1110,1,0,C^FD" + eliminarDiacriticos(dataToWrite.string_specs) + "^FS \
    ^PQ" + numbrePrint + "\
    ^XZ", undefined, errorCallback);

  }
  */
}

export function PrintPallet(dataToWrite, numbrePrint, typeLabel) {
  // Etiqueta Arandano
  if (typeLabel == 1) {
    var detalles = "";

    var cordy1 = 440;
    var cordy2 = 470;
    var cordy3 = 500;
    var cordy4 = 540;

    var total_cantidad = 0;

    for (var i = 0; i < dataToWrite.contents.length; i++) {
      detalles +=
        "^CF0,28\
      ^FO50," +
        cordy1 +
        "^FD" +
        eliminarDiacriticos(dataToWrite.contents[i].origin) +
        "^FS\
      ^FO50," +
        cordy2 +
        "^FD" +
        eliminarDiacriticos(dataToWrite.contents[i].plant) +
        " ^FS\
      ^FO50," +
        cordy3 +
        "^FD" +
        eliminarDiacriticos(dataToWrite.contents[i].variety_name) +
        " - " +
        formato(dataToWrite.contents[i].creation_date) +
        " - " +
        eliminarDiacriticos2(dataToWrite.contents[i].string_specs) +
        "^FS\
      ^CF0,50\
      ^FO710," +
        cordy2 +
        "^FD" +
        dataToWrite.contents[i].quantity +
        "^FS\
      ^FO50," +
        cordy4 +
        "^GB750,1,1^FS";

      total_cantidad += parseInt(dataToWrite.contents[i].quantity);

      cordy1 = cordy1 + 130;
      cordy2 = cordy2 + 130;
      cordy3 = cordy3 + 130;
      cordy4 = cordy4 + 130;
    }

    selected_device.send(
      "^XA\
			^FX Top section with company logo, name and address.\
			^CF0,150\
      ^FO50,20^FD" +
        dataToWrite.number +
        "^FS\
      ^FO670,187^BY4,2.0,65^BQ,2,4^FDQA," +
        dataToWrite.number +
        "^FS\
			^CF0,60\
			^FO45,170^FD" +
        dataToWrite.client_customer +
        "^FS\
			^CF0,40\
			^FO50,240^GB750,1,3^FS\
			^CF0,35\
      ^FO50,255^FD" +
        eliminarDiacriticos2(dataToWrite.contents[0].container.text) +
        "^FS\
      ^CF0,45\
			^FO50,295^FD" +
        eliminarDiacriticos(dataToWrite.contents[0].condition) +
        "^FS\
			^FO50,335^FD" +
        eliminarDiacriticos(dataToWrite.contents[0].product_type_name) +
        "^FS\
			^CF0,40\
			^FO50,380^GB750,1,3^FS\
			^FO50,420^GB750,1,3^FS\
			^CF0,35\
			^FO50,395^FDDETALLE^FS\
			^FO638,395^FDCANTIDAD^FS\
			^FX Seccion de detalle segun SAG\
			" +
        detalles +
        "\
			^CF0,100\
			^FO50," +
        cordy1 +
        "^FDTotal:" +
        total_cantidad +
        "^FS\
			^FX  section with barcode.\
			^BY2,2,100\
			^FX Cantidada de etiquetas.\
			^PQ" +
        numbrePrint +
        "\
			^XZ",
      successCallback,
      errorCallback
    );
  }

  // Etiqueta tipo 2
  if (typeLabel == 2) {
    var detalles = "";

    var cordy1 = 440;
    var cordy2 = 480;
    var cordy3 = 520;
    var cordy33 = 560;
    var cordy4 = 600;

    var total_cantidad = 0;

    for (var i = 0; i < dataToWrite.contents.length; i++) {
      detalles +=
        "^CF0,40\
      ^FO50," +
        cordy1 +
        "^FD" +
        eliminarDiacriticos(dataToWrite.contents[i].origin) +
        "^FS\
      ^FO50," +
        cordy2 +
        "^FD" +
        eliminarDiacriticos(dataToWrite.contents[i].plant) +
        " ^FS\
      ^FO50," +
        cordy3 +
        "^FD" +
        eliminarDiacriticos(dataToWrite.contents[i].variety_name) +
        " - " +
        formato(dataToWrite.contents[i].creation_date) +
        " ^FS\
      ^CF0,30\
      ^FO50," +
        cordy33 +
        "^FD" +
        eliminarDiacriticos2(dataToWrite.contents[i].string_specs) +
        " ^FS\
      ^CF0,50\
      ^FO710," +
        cordy2 +
        "^FD" +
        dataToWrite.contents[i].quantity +
        "^FS\
      ^FO50," +
        cordy4 +
        "^GB750,1,1^FS";

      total_cantidad += parseInt(dataToWrite.contents[i].quantity);

      cordy1 = cordy1 + 170;
      cordy2 = cordy2 + 170;
      cordy3 = cordy3 + 170;
      cordy33 = cordy33 + 170;
      cordy4 = cordy4 + 170;
    }

    selected_device.send(
      "^XA\
			^FX Top section with company logo, name and address.\
			^CF0,150\
			^FO50,20^FD" +
        dataToWrite.number +
        "^FS\
			^FO670,187^BY4,2.0,60^BQ,2,4^FDQA," +
        dataToWrite.number +
        "^FS\
			^CF0,45\
			^FO45,170^FD" +
        dataToWrite.client_customer +
        "^FS\
			^CF0,35\
			^FO50,240^GB750,1,3^FS\
			^CF0,35\
      ^FO50,255^FD" +
        eliminarDiacriticos2(dataToWrite.contents[0].container.text) +
        "^FS\
      ^CF0,45\
			^FO50,295^FD" +
        eliminarDiacriticos(dataToWrite.contents[0].condition) +
        "^FS\
			^FO50,335^FD" +
        eliminarDiacriticos(dataToWrite.contents[0].product_type_name) +
        "^FS\
			^CF0,40\
			^FO50,380^GB750,1,3^FS\
			^FO50,420^GB750,1,3^FS\
			^CF0,40\
			^FO50,388^FDDETALLE^FS\
			^FO638,388^FDCANTIDAD^FS\
			^FX Seccion de detalle segun SAG\
      " +
        detalles +
        "\
      ^CF0,80\
      ^FO50," +
        cordy1 +
        "^FDTotal:" +
        total_cantidad +
        "^FS\
      ^FO50," +
        (parseInt(cordy1) + parseInt(70)) +
        "^FDTotal KG:" +
        dataToWrite.total_net_kilograms +
        "^FS\
			^FX  section with barcode.\
			^BY2,2,100\
			^FX Cantidada de etiquetas.\
			^PQ" +
        numbrePrint +
        "\
			^XZ",
      successCallback,
      errorCallback
    );
  }

  // Etiqueta tipo 3
  if (typeLabel == 3) {
    var detalles = "";

    var cordy1 = 440;
    var cordy2 = 480;
    var cordy3 = 520;
    var cordy33 = 560;
    var cordy4 = 600;

    var total_cantidad = 0;
    var total_kilogramos = "";

    if (dataToWrite.contents[0].container.value.bulk == true) {
      total_kilogramos = " KG: " + dataToWrite.total_net_kilograms;
    }

    for (var i = 0; i < dataToWrite.contents.length; i++) {
      detalles +=
        "^CF0,40\
      ^FO50," +
        cordy1 +
        "^FD" +
        eliminarDiacriticos(dataToWrite.contents[i].origin) +
        "^FS\
      ^FO50," +
        cordy2 +
        "^FD" +
        eliminarDiacriticos(dataToWrite.contents[i].plant) +
        " ^FS\
      ^FO50," +
        cordy3 +
        "^FD" +
        eliminarDiacriticos(dataToWrite.contents[i].variety_name) +
        " - " +
        formato(dataToWrite.contents[i].creation_date) +
        " ^FS\
      ^CF0,30\
      ^FO50," +
        cordy33 +
        "^FD" +
        eliminarDiacriticos2(dataToWrite.contents[i].string_specs) +
        " ^FS\
      ^CF0,50\
      ^FO710," +
        cordy2 +
        "^FD" +
        dataToWrite.contents[i].quantity +
        "^FS\
      ^FO50," +
        cordy4 +
        "^GB750,1,1^FS";

      total_cantidad += parseInt(dataToWrite.contents[i].quantity);

      cordy1 = cordy1 + 170;
      cordy2 = cordy2 + 170;
      cordy3 = cordy3 + 170;
      cordy33 = cordy33 + 170;
      cordy4 = cordy4 + 170;
    }

    selected_device.send(
      "^XA\
			^FX Top section with company logo, name and address.\
			^CF0,150\
			^FO50,20^FD" +
        dataToWrite.number +
        "^FS\
			^FO670,187^BY4,2.0,65^BQ,2,4^FDQA," +
        dataToWrite.number +
        "^FS\
			^CF0,45\
			^FO45,170^FD" +
        dataToWrite.client_customer +
        "^FS\
			^CF0,40\
			^FO50,240^GB750,1,3^FS\
			^CF0,35\
      ^FO50,255^FD" +
        eliminarDiacriticos2(dataToWrite.contents[0].container.text) +
        "^FS\
      ^CF0,45\
			^FO50,295^FD" +
        eliminarDiacriticos(dataToWrite.contents[0].condition) +
        "^FS\
			^FO50,335^FD" +
        eliminarDiacriticos(dataToWrite.contents[0].product_type_name) +
        "^FS\
			^CF0,40\
			^FO50,380^GB750,1,3^FS\
			^FO50,420^GB750,1,3^FS\
			^CF0,40\
			^FO50,388^FDDETALLE^FS\
			^FO638,388^FDCANTIDAD^FS\
			^FX Seccion de detalle segun SAG\
      " +
        detalles +
        "\
      ^CF0,90\
			^FO50," +
        cordy1 +
        "^FD" +
        total_kilogramos +
        "^FS\
			^FX  section with barcode.\
			^BY2,2,100\
			^FX Cantidada de etiquetas.\
			^PQ" +
        numbrePrint +
        "\
			^XZ",
      successCallback,
      errorCallback
    );
  }

  // Etiqueta tipo 4
  if (typeLabel == 4) {
    var detalles = "";

    var cordy1 = 445;
    var cordy2 = 520;
    var cordy3 = 580;
    var cordy33 = 655;
    var cordy4 = 730;

    var total_cantidad = 0;

    for (var i = 0; i < dataToWrite.contents.length; i++) {
      detalles +=
        "^CF0,70\
      ^FO50," +
        cordy1 +
        "^FD" +
        eliminarDiacriticos(dataToWrite.contents[i].origin) +
        "^FS\
      ^CF0,50\
      ^FO50," +
        cordy2 +
        "^FD" +
        eliminarDiacriticos(dataToWrite.contents[i].plant) +
        " ^FS\
      ^CF0,70\
      ^FO50," +
        cordy3 +
        "^FD" +
        eliminarDiacriticos(dataToWrite.contents[i].variety_name) +
        " - " +
        formato(dataToWrite.contents[i].creation_date) +
        " ^FS\
      ^CF0,70\
      ^FO50," +
        cordy33 +
        "^FD" +
        eliminarDiacriticos2(dataToWrite.contents[i].string_specs) +
        " ^FS\
      ^CF0,70\
      ^FO50," +
        cordy4 +
        "^GB750,1,1^FS";

      total_cantidad += parseInt(dataToWrite.contents[i].quantity);

      cordy1 = cordy1 + 305;
      cordy2 = cordy2 + 305;
      cordy3 = cordy3 + 305;
      cordy33 = cordy33 + 305;
      cordy4 = cordy4 + 305;
    }

    selected_device.send(
      "^XA\
			^FX Top section with company logo, name and address.\
			^CF0,150\
			^FO50,20^FD" +
        dataToWrite.number +
        "^FS\
			^FO670,187^BY4,2.0,60^BQ,2,4^FDQA," +
        dataToWrite.number +
        "^FS\
			^CF0,45\
			^FO45,170^FD" +
        dataToWrite.client_customer +
        "^FS\
			^CF0,40\
			^FO50,240^GB750,1,3^FS\
			^CF0,35\
      ^FO50,255^FD" +
        eliminarDiacriticos2(dataToWrite.contents[0].container.text) +
        "^FS\
      ^CF0,45\
			^FO50,295^FD" +
        eliminarDiacriticos(dataToWrite.contents[0].condition) +
        "^FS\
			^FO50,335^FD" +
        eliminarDiacriticos(dataToWrite.contents[0].product_type_name) +
        "^FS\
			^CF0,40\
			^FO50,380^GB750,1,3^FS\
			^FO50,420^GB750,1,3^FS\
			^CF0,35\
			^FO50,388^FDDETALLE^FS\
			^FX Seccion de detalle segun SAG\
      " +
        detalles +
        "\
      ^CF0,80\
      ^FO50," +
        cordy1 +
        "^FDTotal:" +
        total_cantidad +
        "^FS\
      ^FO50," +
        (parseInt(cordy1) + parseInt(80)) +
        "^FDTotal KG:" +
        dataToWrite.total_net_kilograms +
        "^FS\
			^FX  section with barcode.\
			^BY2,2,100\
			^FX Cantidada de etiquetas.\
			^PQ" +
        numbrePrint +
        "\
			^XZ",
      successCallback,
      errorCallback
    );
  }

  // Etiqueta tipo 5
  if (typeLabel == 5) {
    var detalles = "";

    var cordy1 = 445;
    var cordy2 = 520;
    var cordy3 = 580;
    var cordy33 = 655;
    var cordy4 = 730;

    var total_cantidad = 0;

    for (var i = 0; i < dataToWrite.contents.length; i++) {
      detalles +=
        "^CF0,70\
       ^FO50," +
        cordy1 +
        "^FD" +
        eliminarDiacriticos(dataToWrite.contents[i].origin) +
        "^FS\
       ^CF0,50\
       ^FO50," +
        cordy2 +
        "^FD" +
        eliminarDiacriticos(dataToWrite.contents[i].plant) +
        " ^FS\
       ^CF0,70\
       ^FO50," +
        cordy3 +
        "^FD" +
        eliminarDiacriticos(dataToWrite.contents[i].variety_name) +
        " - " +
        formato(dataToWrite.contents[i].creation_date) +
        " ^FS\
       ^CF0,70\
       ^FO50," +
        cordy33 +
        "^FD" +
        eliminarDiacriticos2(dataToWrite.contents[i].string_specs) +
        " ^FS\
       ^CF0,70\
       ^FO50," +
        cordy4 +
        "^GB750,1,1^FS";

      total_cantidad += parseInt(dataToWrite.contents[i].quantity);

      cordy1 = cordy1 + 305;
      cordy2 = cordy2 + 305;
      cordy3 = cordy3 + 305;
      cordy33 = cordy33 + 305;
      cordy4 = cordy4 + 305;
    }

    selected_device.send(
      "^XA\
       ^FX Top section with company logo, name and address.\
       ^CF0,150\
       ^FO50,20^FD" +
        dataToWrite.number +
        "^FS\
       ^FO670,187^BY4,2.0,60^BQ,2,4^FDQA," +
        dataToWrite.number +
        "^FS\
       ^CF0,45\
       ^FO45,170^FD" +
        dataToWrite.client_customer +
        "^FS\
       ^CF0,40\
       ^FO50,240^GB750,1,3^FS\
       ^CF0,35\
       ^FO50,255^FD" +
        eliminarDiacriticos2(dataToWrite.contents[0].container.text) +
        "^FS\
       ^CF0,45\
       ^FO50,295^FD" +
        eliminarDiacriticos(dataToWrite.contents[0].condition) +
        "^FS\
       ^FO50,335^FD" +
        eliminarDiacriticos(dataToWrite.contents[0].product_type_name) +
        "^FS\
       ^CF0,40\
       ^FO50,380^GB750,1,3^FS\
       ^FO50,420^GB750,1,3^FS\
       ^CF0,35\
       ^FO50,388^FDDETALLE^FS\
       ^FX Seccion de detalle segun SAG\
       " +
        detalles +
        "\
       ^CF0,80\
       ^FO50," +
        cordy1 +
        "^FDENVASES:" +
        total_cantidad +
        "^FS\
       ^FO50," +
        (parseInt(cordy1) + parseInt(80)) +
        "^FDUN:" +
        dataToWrite.total_net_kilograms +
        "^FS\
       ^FX  section with barcode.\
       ^BY2,2,100\
       ^FX Cantidada de etiquetas.\
       ^PQ" +
        numbrePrint +
        "\
       ^XZ",
      successCallback,
      errorCallback
    );
  }

  // Etiqueta tipo 6
  if (typeLabel == 6) {
    let details = "";
    let line_y = 390;
    let total_cantidad = 0;

    dataToWrite.contents.forEach((item, idx) => {
      details += `^FT${line_y},54^A0R,20,19^FH\^FD${item.origin_details.code}^FS`;
      details += `^FT${line_y},241^A0R,20,19^FH\^FD${eliminarDiacriticos2(item.origin_details.township)}^FS`;
      details += `^FT${line_y},398^A0R,20,19^FH\^FD${formato(item.creation_date)}^FS`;
      details += `^FT${line_y},563^A0R,20,19^FH\^FD${eliminarDiacriticos2(item.variety_name)}^FS`;
      details += `^FT${line_y},764^A0R,20,19^FH\^FD${item.custom_fields.calibre || "-"}^FS`;
      details += `^FT${line_y},923^A0R,20,19^FH\^FDCAT 1^FS`;
      details += `^FT${line_y},1092^A0R,20,19^FB27,1,0,R^FH\^FD${item.quantity}^FS`;
      total_cantidad += parseInt(item.quantity);
      line_y -= 30;
    });

    selected_device.send(
      `^XA~TA000~JSN^LT0^MNW^MTT^PON^PMN^LH0,0^JMA^PR6,6~SD15^MD10^JUS^LRN^CI0^XZ
      ^XA
      ^MMT
      ^PW815
      ^LL1215
      ^LS0
      ^FO20,17^GB779,1178,4^FS
      ^FO730,19^GB69,1176,4^FS
      ^FO465,17^GB270,453,4^FS
      ^FO551,465^GB184,730,4^FS
      ^FO551,465^GB71,730,4^FS
      ^FO466,17^GB91,1178,4^FS
      ^FO409,17^GB62,1178,4^FS
      ^FO20,17^GB127,1178,4^FS
      ^FO20,376^GB127,479,4^FS
      ^FT751,466^A0R,39,38^FH\^FDTARJA PALLET^FS
      ^FT626,584^A0R,102,100^FH\^FD${dataToWrite.number}^FS
      ^FT688,34^A0R,23,24^FH\^FDFECHA/DATE: ${formato(dataToWrite.contents[0].creation_date)}^FS
      ^FT660,34^A0R,23,24^FH\^FDPLANTA/PLANT: ${eliminarDiacriticos2(dataToWrite.contents[0].plant)}^FS
      ^FT632,34^A0R,23,24^FH\^FDCOD.PACKING: ${dataToWrite.contents[0].plant_details.plant_code}^FS
      ^FT604,34^A0R,23,24^FH\^FDCOMUNA: ${eliminarDiacriticos2(dataToWrite.contents[0].plant_details.township)}^FS
      ^FT576,34^A0R,23,24^FH\^FDPROVINCIA: ${eliminarDiacriticos2(dataToWrite.contents[0].plant_details.province)}^FS
      ^FT521,34^A0R,23,24^FH\^FDEMBALAJE/PACKAGING^FS
      ^FT492,54^A0R,23,24^FH\^FD${eliminarDiacriticos2(dataToWrite.contents[0].container.text)}^FS
      ^FT521,487^A0R,23,24^FH\^FDETIQUETA/LABEL^FS
      ^FT492,511^A0R,23,24^FH\^FD${eliminarDiacriticos2(dataToWrite.contents[0].string_specs)}^FS
      ^FT443,39^A0R,20,19^FB101,1,0,C^FH\^FDCOD.^FS
      ^FT419,39^A0R,20,19^FB101,1,0,C^FH\^FDPRODUCTOR^FS
      ^FT443,224^A0R,20,19^FB101,1,0,C^FH\^FDCOMUNA^FS
      ^FT419,224^A0R,20,19^FB101,1,0,C^FH\^FDPRODUCTOR^FS
      ^FT443,409^A0R,20,19^FB86,1,0,C^FH\^FDFECHA^FS
      ^FT419,409^A0R,20,19^FB86,1,0,C^FH\^FDEMBALAJE^FS
      ^FT431,579^A0R,20,19^FB83,1,0,C^FH\^FDVARIEDAD^FS
      ^FT431,746^A0R,20,19^FB68,1,0,C^FH\^FDCALIBRE^FS
      ^FT431,898^A0R,20,19^FB92,1,0,C^FH\^FDCATEGORIA^FS
      ^FT431,1074^A0R,20,19^FB51,1,0,C^FH\^FDCAJAS^FS
      ${details}
      ^FT29,677^BQN,2,5
      ^FH\^FDLA,${dataToWrite.number}^FS
      ^FT111,861^A0R,23,24^FH\^FDCAJAS/BOXES^FS
      ^FT32,943^A0R,79,79^FH\^FD${total_cantidad}^FS
      ^PQ${numbrePrint},0,1,Y^XZ`,
      successCallback,
      errorCallback
    );
  }
}

function errorCallback(errorMessage) {
  console.log(errorMessage);
  miniToastr.info("Problemas al realizar la operación", "");
}

export function successCallback(successMessage) {
  miniToastr.info("Impresión realizada con éxito.", "");
}

function formato(texto) {
  return texto.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, "$3/$2/$1");
}

function eliminarDiacriticos(texto) {
  if (texto === null) {
    return "Sin informacion";
  } else {
    return texto
      .toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  }
}

function eliminarDiacriticos2(texto) {
  if (texto === null) {
    return "Sin informacion";
  } else {
    let textAux = texto.split("~").join("-");
    return textAux.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }
}

function fechaActual() {
  let date = new Date();

  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();

  if (month < 10) {
    return `${day}-0${month}-${year}`;
  } else {
    return `${day}-${month}-${year}`;
  }
}

function pad(num, size) {
  num = num.toString();
  while (num.length < size) num = "0" + num;
  return num;
}
